export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

/**
 * OAuth giriş adresi; çalışma anında üretilir, böylece yönlendirme adresi geçerli origin'i yansıtır.
 * VITE_OAUTH_PORTAL_URL ya da VITE_APP_ID tanımsız veya geçersizse null döner (fırlatmaz): çağıran taraf
 * yönlendirme yapmaz ve "giriş şu anda yapılamıyor" durumunu gösterir. Önceden tanımsız ortam değişkeni
 * new URL("undefined/app-auth") ile "Invalid URL" fırlatıp /dosyalar'ı render sırasında çökertiyordu.
 */
export const getLoginUrl = (): string | null => {
  const oauthPortalUrl = import.meta.env.VITE_OAUTH_PORTAL_URL;
  const appId = import.meta.env.VITE_APP_ID;
  if (!oauthPortalUrl || !appId || typeof window === "undefined") return null;

  try {
    const redirectUri = `${window.location.origin}/api/oauth/callback`;
    const state = btoa(redirectUri);

    const url = new URL(`${oauthPortalUrl}/app-auth`);
    url.searchParams.set("appId", appId);
    url.searchParams.set("redirectUri", redirectUri);
    url.searchParams.set("state", state);
    url.searchParams.set("type", "signIn");

    return url.toString();
  } catch {
    return null;
  }
};
